module.exports = __webpack_public_path__ + "media/images/project/check-mark-e33995db7d20612809740f6e02f16a8c.svg";